import { NotificationPayload, NotificationType, VotesRevealedNotificationPayload } from "@appfire/poker-core";

export function isVotesRevealedNotificationPayload<TItem, TParticipant>(
  type: NotificationType,
  payload: NotificationPayload<TItem, TParticipant>,
): payload is VotesRevealedNotificationPayload<TItem, TParticipant> {
  return type === NotificationType.VOTES_REVEALED;
}
